import { forwardRef } from 'react'
import styles from './EmptyImage.module.scss'

type EmptyImageProps = {
	readonly isTwoColumnSize: boolean
}

export const EmptyImage = forwardRef<HTMLDivElement, EmptyImageProps>(
	({ isTwoColumnSize }, ref) => (
		<div
			ref={ref}
			className={isTwoColumnSize ? styles.emptyFeatured : styles.empty}
		/>
	)
)
